import { render, staticRenderFns } from "./DevicePerformance.vue?vue&type=template&id=d7d81972&scoped=true&"
import script from "./DevicePerformance.vue?vue&type=script&lang=js&"
export * from "./DevicePerformance.vue?vue&type=script&lang=js&"
import style0 from "./DevicePerformance.vue?vue&type=style&index=0&id=d7d81972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d81972",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2687757686/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d81972')) {
      api.createRecord('d7d81972', component.options)
    } else {
      api.reload('d7d81972', component.options)
    }
    module.hot.accept("./DevicePerformance.vue?vue&type=template&id=d7d81972&scoped=true&", function () {
      api.rerender('d7d81972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/DevicePerformance.vue"
export default component.exports